<template>
  <div>
    <Vcode
      :show="show"
      :successText="$t('hzmbG.Vcode.successText')"
      :failText="$t('hzmbG.Vcode.failText')"
      :sliderText="$t('hzmbG.Vcode.sliderText')"
      @success="
        show = false;
        success = true;
      "
      @close="show = false"
    />
    <div v-if="success" class="vcode-btn vcode-btn--success">
      <i class="el-icon-check"></i>
      {{ $t("hzmbG.Vcode.successText") }}
    </div>
    <div v-if="!success" class="vcode-btn" @click="show = true">
      {{ $t("hzmbG.Vcode.title") }}
    </div>
  </div>
</template>

<script>
import Vcode from "vue-puzzle-vcode";
export default {
  components: { Vcode },
  data() {
    return {
      show: false,
      success: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.vcode-btn {
  padding: 8px;
  text-align: center;
  font-size: 18px;
  border: 1px solid #909399;
  background: #f5f7fa;
  border-radius: 3px;
  cursor: pointer;
}
.vcode-btn.vcode-btn--success {
  color: #67c23a;
  background-color: #efffe7;
}
</style>
